import { useCallback, useState } from "react";
export default function useNavigationStack(initial) {
    const [stack, setStack] = useState([initial]);
    const push = useCallback((key) => {
        setStack((prev) => [...prev, key]);
    }, []);
    const pop = useCallback(() => {
        setStack((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
    }, []);
    const activeIndex = stack.length - 1;
    const activeKey = stack[activeIndex];
    return {
        stack,
        activeIndex,
        activeKey,
        push,
        pop,
        canGoBack: stack.length > 1,
    };
}
//# sourceMappingURL=useNavigationStack.js.map